
      export const versions = {
        commit: 'b67435e55ac06317e84041b06c499210724fde5c',
        branch: 'HEAD'
      };
